const forceLogoutSSOFlag = 'ssoUserForceLogout';

export function setForceLogoutFlagForSSOSignUp() {
  window.localStorage.setItem(forceLogoutSSOFlag, 'true');
}

export function getForceLogoutFlagForSSOSignUp() {
  return window.localStorage.getItem(forceLogoutSSOFlag);
}

export function clearForceLogoutFlagForSSOSignUp() {
  window.localStorage.removeItem(forceLogoutSSOFlag);
}
